import { Component, h } from 'preact'
import Button from './../ui-components/Button'
import Dropdown from '../dropdown'
import DropdownList from '../dropdown/DropdownList'
import Icon from '../assets'
import Portal from 'preact-portal'
import Phrase from '../../libs/translationsUtils/phrase'
import { t } from '../../libs/translationsUtils/translations'

interface Props {
  joinGroup: () => void,
  leaveGroup: () => void,
  isLoading: boolean,
  isUserMember: boolean,
  groupId: number
}

export class GroupActionButtons extends Component<Props, {}> {
  render ({ joinGroup, leaveGroup, isLoading, isUserMember, groupId } : Props) {
    return (
      <Portal key='new-button' into={'.group-details-page_action-buttons'}>
        {
          !isUserMember ? (
            <Button
              type='button'
              class='btn--cta'
              loading={isLoading}
              onClick={joinGroup}
            ><Phrase p='groups.join.group' /></Button>
          ) : (
            <div className='group-details_hero__user-actions'>
              <Dropdown
                trigger={<Button
                  type='button'
                  class='group-details_hero__user-action-dropdown-btn'
                ><Phrase p='groups.you.are.member' /><Icon customClass={'icon-dropdown'} width={24} icon={'chevronDown'} /></Button>}
                triggerClass='group-details_hero__user-action-dropdown'
              >
                <DropdownList
                  align={'center'}
                  items={[{
                    title: t('Forum', 'groups.leave.group'),
                    onClick: leaveGroup,
                    variant: 'primary'
                  }]}
                  hasSearch={false}
                />
              </Dropdown>

              <a
                type='button'
                class='btn--cta'
                href={`/topic/new?fid=${groupId}`}
              ><Phrase p='main.navigation.add_topic' /></a>
            </div>
          )
        }

      </Portal>

    )
  }
}

export default GroupActionButtons
